module.exports = __webpack_public_path__ + "static/media/bristol-myers.15ef65c1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/labs/bristol-myers.png
// module id = 123
// module chunks = 0